import React, { useEffect } from 'react';
import queryString from 'query-string';

import { useLocalization } from "../../containers/I18nProvider";
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';
import './style.scss';
import LoginForm from './LoginForm';

const Login = ({ location }) => {
  const {translate} = useLocalization();
  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);

  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type)
      return false;
    return true;
  }

  useEffect(() => {
    document.body.className = 'blutelco-oauth-body';
    document.title = 'BLUTELCO SAS';
  }, []);

  return (
    <div className="blutelco-oauth">
      {
        _validateParams()
          ? <LoginForm
            api={api}
            location={location} />
          : <RequestLoginErrorMessage
            onlyMessage={true}
            message={translate('RequestLoginErrorMessage')} />}
    </div>
  );
}

export default Login;
